import React from 'react';
import { PromotionCard as PromotionCardComponent } from '@thd-olt-component-react/promotion-card';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function PromotionCard() {
  return (
    <ErrorBoundary name="promotion-card">
      <QueryProvider cacheKey="promotion-card">
        <PromotionCardComponent />
      </QueryProvider>
    </ErrorBoundary>
  );
}